import { jsx, jsxs } from "react/jsx-runtime";
import { theme } from "../theme/index.js";
import { iconFactory } from "./Icon.js";
const IconTemplafy = iconFactory('IconTemplafy', ()=>/*#__PURE__*/ jsxs("g", {
        fill: "none",
        fillRule: "evenodd",
        clipRule: "evenodd",
        "data-icon-type": "fill",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M0 4.5C0 2.01472 2.01472 0 4.5 0H19.5C21.9853 0 24 2.01472 24 4.5V19.5C24 21.9853 21.9853 24 19.5 24H4.5C2.01472 24 0 21.9853 0 19.5V4.5Z"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M11 21V16.7284C11 14.6685 9.20944 13 7 13V17.2716C7 19.3315 8.79056 21 11 21Z",
                fill: theme.color.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.82784 10.0349C10.548 9.43667 11 8.607 11 7.68993V7H7V11C8.10384 11 9.10248 10.6288 9.82784 10.0306V10.0349Z",
                fill: theme.color.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M13 3V7.27156C13 9.33149 14.7906 11 17 11V6.72844C17 4.6685 15.2094 3 13 3Z",
                fill: theme.color.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.1722 13.9651C13.452 14.5633 13 15.393 13 16.3101V17H17V13C15.8962 13 14.8975 13.3712 14.1722 13.9694V13.9651Z",
                fill: theme.color.white
            })
        ]
    }));
export { IconTemplafy };
